import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { req_download_coursemap_data } from "../../api";
import { COURSEMAP_API_URL } from "../../utils/contrains";
import { Spin } from "antd";
class DepartmentQuailtyCommom extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    manual: PropTypes.object.isRequired,
    doctype: PropTypes.string.isRequired,
  };
  state = { loading: false };

  UNSAFE_componentWillMount() {
    this.api_downloadfile_coursemap_data();
  }

  api_downloadfile_coursemap_data = async () => {
    const { GidLearnMapMeta } = this.props.manual;
    //console.log(GidLearnMapMeta);
    // download file data
    this.setState({ loading: true });
    const fileUrl = await req_download_coursemap_data(
      this.props.doctype,
      GidLearnMapMeta
    );
    if (fileUrl.key) {
      let a = document.createElement("a");
      a.href = COURSEMAP_API_URL + "/" + fileUrl.key;
      a.target = "_blank";
      a.download = "清單";
      a.click();
      this.setState({ loading: false });
    } else {
      this.setState({ loading: false });
    }
    // download file link
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading } = this.state;
    // console.log(this.props.manual);
    return (
      <>
        {loading ? (
          <div style={{ width: "150px" }}>
            <Spin style={{ marginRight: "5px" }} />
            <span>數據處理中</span>
          </div>
        ) : (
          <div style={{ width: "150px" }}>
            <i
              className="fa fa-check-square"
              style={{ color: "green", marginRight: "5px" }}
            ></i>
            <span style={{ color: "green" }}>接收完畢</span>
          </div>
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(DepartmentQuailtyCommom);
